import React from 'react';
import JobRecruiterWidgetScripts from "./JobRecruiterWidgetScripts";
import './JobRecruiterWidget.scss';

const JobRecruiterWidget = () => (
    <div className="jobRecruiterWidget" style={{margin: '40px 0', overflowX: 'scroll'}}>
        <div id="jobRecruiterWidget" className="smartWidget">
            <JobRecruiterWidgetScripts/>
        </div>
    </div>
);

export default JobRecruiterWidget;



// WEBPACK FOOTER //
// ./frontend/components/JobRecruiterWidget/JobRecruiterWidget.jsx